import React, { useState } from "react"
import { Navigate } from "react-router-dom"
import getAppConfig from "~/utils/getAppConfig"
import { useToast } from "~/utils/Toast"

import { apiWorkspaceContacts, apiWorkspaceContactCategories } from "~/routes"
import useFetchResource from "~/hooks/useFetchResource"

import PageContainer from "~/library/PageContainer"
import LoadingWrapper from "~/library/LoadingWrapper"
import ContactForm from "./ContactForm"

type ContactCategoryOption = {
    id: string
    name: string
}

const NewContact = () => {
    const { venueSlug } = getAppConfig()
    const [createdContactId, setCreatedContactId] = useState<string | null>(null)
    const toast = useToast()

    const { data: contactCategories, isLoading: categoriesLoading } = useFetchResource<
    ContactCategoryOption[],
    "contact_categories"
    >(apiWorkspaceContactCategories.index.path({ venue_slug: venueSlug }), "contact_categories", {})

    const handleSubmit = (formValues: any) => {
        const data = {
            venue_slug: venueSlug,
            contact: formValues,
        }

        const req = apiWorkspaceContacts.create({ data })

        req
            .then((response) => {
                if (response.status === "ok") {
                    setCreatedContactId(response.prefixId)
                    toast("Contact created successfully", "success")
                } else {
                    toast(
                        `Error creating contact. ${response.errors?.join(", ") || "Please try again"}`,
                        "danger"
                    )
                }
            })
            .catch((res) => {
                const errorMessage =
                    res.body?.errors?.join(", ") ||
                    res.body?.error ||
                    "Please try again"
                toast(`Error creating contact. ${errorMessage}`, "danger")
            })
    }

    if (createdContactId) {
        return <Navigate to={`/contacts/${createdContactId}`} />
    }

    return (
        <PageContainer>
            <LoadingWrapper isLoading={categoriesLoading}>
                <div className="row h-100">
                    <div className="col-8 offset-2 align-center mt-4">
                        <h3 className="mb-3">New Contact</h3>
                        {contactCategories && (
                            <ContactForm
                                onSubmit={handleSubmit}
                                contactCategories={contactCategories}
                            />
                        )}
                    </div>
                </div>
            </LoadingWrapper>
        </PageContainer>
    )
}

export default NewContact
